import React, { Component, Fragment } from 'react';
import NotificationSystem from 'react-notification-system';
import {BeatLoader} from 'react-spinners';
import { get} from "../../../server/actions";
import {groupBy} from './../../../server/util';
import Modal from 'react-modal'
import ModalVideo from 'react-modal-video';
//import 'react-modal-video/scss/modal-video.scss';
import "./help.css";

const modalStyles = {
    content: {
        top: '40%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '50%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};

class Help extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            videoUrl:'',
            search:'',
            masterList:[],
            AllHelps:{},
            filterHelps:{},
            modalIsOpen:false,
            selectedItem:{}
        }
    }
    openModal=(url)=> {
        this.setState({ isOpen: true });
        this.setState({videoUrl:url});
        console.log("Video link:::::",this.state.videoUrl);
      }
    closeModal = () => {
        this.setState({isOpen:false});
      };
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        this.getAllHelps();
     }
     openAttachment=(item)=>{
        if(item.type=="Video"){
            this.setState({modalIsOpen:true, selectedItem:{...item}});
        }else{
            this.openDocument(item.link);
        }
     }

     formatObject=(list=[])=>{
        const categoryGroup=groupBy(list,'category');
                const catSubCatGroup={};
                Object.keys(categoryGroup).map(categoryGroupName=>{
                    const subCatGroup=groupBy(categoryGroup[categoryGroupName]||[],'subCategory');
                    catSubCatGroup[categoryGroupName]={...subCatGroup};
                });
                return catSubCatGroup;

     }
    
    getAllHelps=()=>{
        this.setState({loading:true})
        get(`/helpDetails?access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response);
            }
            return response.json();
            }).then(data => {
                const items=data._embedded.helpDetails||[];
                const catSubCatGroup=this.formatObject(items);                
            
            this.setState({
                AllHelps:catSubCatGroup , masterList:items, loading: false},()=>{
                    this.filterData(items,catSubCatGroup)
                });
        }).catch(
            (error) => {
                this.setState({loading: false});
                console.log('topicsList', error);
            }
        )     
    }
    filterData=(masterList=[],mainObj={})=>{
        const {search}=this.state;
        if((search||'').length<=0){
            this.setState({filterHelps:mainObj});
        }else{
            const filterItems=masterList.filter(item=>{
                return (item.helpTopic||'').toLowerCase().includes(search.toLowerCase())
            });

            this.setState({filterHelps:this.formatObject(filterItems)});
        }
    }
    openDocument=(url)=>{
        var anchor = document.createElement('a');
        anchor.href = url; //window.URL.createObjectURL(newBlob);
   
        //anchor.name=fileName+'.pdf';
        //anchor.dataset.downloadurl = ['application/pdf', anchor.download, anchor.href].join(':');

        if(typeof InstallTrigger !== 'undefined'){
            window.open(anchor.href,'_blank');
            return;
        }    
        anchor.target='_blank';
        anchor.click();
    }
    render() {
        const {search, loading, filterHelps }=this.state;
        return (
            <div>               
                <NotificationSystem ref="notificationSystem"/>
                <section className=" full-width clearfix">
                    <div className='sweet-loading'
                         style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={loading}
                        />
                    </div>
            
                    <div className="container">
                        <div className="sectionTitle col-md-12">
                            <h2>
                                <span><i class="fa fa-info-circle" aria-hidden="true"></i> Help</span>
                            </h2>
                        </div>
                        <div className="clearfix"></div>
                        <div className='row form-group'>
                            <div className='col-md-5'>
                                <input type="text" className='form-control' placeholder='Search..' value={search} onChange={(e)=>{
                                    const {masterList, AllHelps}=this.state;
                                    this.setState({search:e.target.value},()=>{
                                        this.filterData(masterList, AllHelps)
                                    })
                                }} /></div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className="panel panel-primary">
                                    <div className="panel-body">
                                    {
                                        Object.keys(filterHelps).length<=0 &&
                                        <div className='row'>
                                            <div className='col-md-12 text-center'>
                                                 <span><i>No Data found</i></span>
                                               
                                            </div>
                                        </div> 
                                    }
                                        <div className="panel-group" id="help-accordion" role="tablist" aria-multiselectable="true">
                                        {
                                            Object.keys(filterHelps).map((cat,i)=>{
                                                return <div className="panel panel-default" key={i}>
                                                    <div className="panel-heading" role="tab" id={`h-cat-${i}`}>
                                                        <h4 className="panel-title">
                                                            <a role="button" data-toggle="collapse" data-parent="#help-accordion" 
                                                            href={`#c-cat-${i}`} aria-expanded={i==0?"true":"false"} 
                                                            aria-controls={`c-cat-${i}`} className={i==0?"":"collapsed"} >
                                                                {cat}
                                                            </a>
                                                        </h4>
                                                    </div>
                                                    <div id={`c-cat-${i}`} className= {i==0?"panel-collapse collapse in":"panel-collapse collapse"} role="tabpanel" aria-labelledby={`h-cat-${i}`}>
                                                        <div className="panel-body">
                                                                {
                                                                    Object.keys(filterHelps[cat]||{}).map((subCat,j)=>{
                                                                    return <Fragment><p><h4 style={{    
                                                                        textTransform: 'none',
                                                                        marginBottom: '5px',
                                                                        fontWeight: 600}}><b>{subCat}</b></h4>
                                                                        <hr style={{margin:'3px'}} />
                                                                        <ul className='list-group' style={{margin: '10px 0px 10px 14px'}}>
                                                                            {
                                                                                ((filterHelps[cat]||{})[subCat]||[]).map((item,k)=>{
                                                                                    return <li className='list-group-item'>                                                                                        
                                                                                        {item.helpTopic} &nbsp; &nbsp; <a href='javascript:void(0)' onClick={()=>{
                                                                                            this.openAttachment(item)
                                                                                        }}><span>{ item.type=='Video'? <i className='fa fa-file-video-o'></i>:<i className='fa fa-file-o'></i>}</span></a>
                                                                                    </li>
                                                                                })
                                                                            }
                                                                        </ul></p></Fragment>
                                                                    })
                                                                }
                                                                </div>
                                                        </div>
                                                    </div>
                                                 
                                            })
                                        }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Modal isOpen={this.state.modalIsOpen}
                        //onRequestClose={() => this.setState({modalIsOpen: false})}
                        style={modalStyles}
                        contentLabel="Activation"
                        ariaHideApp={false}
                    >
                        <div className="row">
                        <button type="button" className="pull-right color-1" onClick={() => {
                                  this.setState({modalIsOpen: false, selectedItem:{}})}}>X</button>
                            <h3 style={{color: '#0000b2', textTransform:'none'}} className="text-center">{this.state.selectedItem.helpTopic||''}</h3>
                            <div className="col-md-12">
                            <div className="embed-responsive embed-responsive-16by9">
                                <iframe className="embed-responsive-item" width="100%" height="100%"                                 
                                src={this.state.selectedItem.link||''} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen"></iframe>
                            </div>
                                   
                            </div>
                        </div>
                    </Modal>
            </div>
     );
 }
}
export default Help;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Help/index.js